<template>
  <div class="text-h5" style="margin-bottom: 44px;">
    Счета бухгалтерского учета
  </div>
  <div class="row">
    <div class="col-7 q-ma-lg">
      <q-table
          title=""
          :rows="bills_list"
          :columns="columns"
          row-key="name"
          flat
          separator="horizontal"
          :rows-per-page-options="[0]"
          @row-click="onRowClick"
      />
    </div>
  </div>
</template>

<script>

import axios from "axios";
import {apiUrl} from "@/config";
import {ref} from "vue";

const columns = [
  { name: 'id', label: '№ п/п', field: 'id', align: 'left' },
  { name: 'bill_id', label: 'Номер счета', field: 'bill_id', align: 'left' },
  { name: 'name', label: 'Название', field: 'name', align: 'left' }
];

export default {
  name: "bills_list",
  data() {
    this.emitter.on('onReceiveBillsList', (data) => {
      console.log(data.items);
      this.bills_list = data.items;
    })
    axios
        .post(apiUrl + '/admin/bills/list/', {}, {auth: this.$store.state.credentials})
        .then((response) => {
          this.emitter.emit('onReceiveBillsList', response.data);
        })
    return {
      bills_list: ref([]),
      columns: ref(columns),
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onRowClick(evt, row, index) {
      this.$router.push({name: 'bill_edit', params: {id: row.id}});
    }
  }
}
</script>

<style scoped>

</style>